import React from 'react';
import Card from '../../../core/layout/Card';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import InstructionAudioListContainer from './InstructionAudioListContainer';
import InstructionAudioListFilterContainer from './InstructionAudioListFilterContainer';

const InstructionAudioListScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: 'Instruction Audios',
        },
      ]}
    />
    <Card
      title="Instruction Audios"
      actions={
        <Button
          type="primary"
          icon="plus"
          label="New Instruction Audio"
          onClick={() => browserHistory.push('/instruction-audios/new')}
        />
      }
    >
      <InstructionAudioListFilterContainer initialFilters={props.location.query} />
      <InstructionAudioListContainer />
    </Card>
  </div>
);
export default InstructionAudioListScene;
